import React from 'react'

import { Col, Form, Button, Row } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const MedioPagoFormGroup = ({ iError, iValue, inputId, selectId, onInputKeyDown, onSelectKeyDown, ...props }) => {
  const [mostrarAyuda, setMostrarAyuda] = React.useState(false)
  const [mediosPagos, setMediosPagos] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.MEDIOSPAGO).then(({ data }) => {
      if (data && data.length > 0) {
        setMediosPagos(data)
      } else {
        setMediosPagos([])
      }
    })
  }, [])

  const medioPagoText = React.useMemo(() => {
    const matchDoc = mediosPagos.find(x => x._id === iValue)

    if (matchDoc) {
      return matchDoc.nombre
    } else {
      return '--'
    }
  }, [iValue, mediosPagos])

  const clickAyuda = React.useCallback(() => {
    setMostrarAyuda(prev => !prev)
  }, [])

  const innerOnInputKeyDown = React.useCallback(
    e => {
      if (onInputKeyDown) {
        onInputKeyDown(e)
      }
    },
    [onInputKeyDown]
  )

  const innerOnSelectKeyDown = React.useCallback(
    e => {
      if (onSelectKeyDown) {
        onSelectKeyDown(e)
      }

      if (e.keyCode === 13 || e.keyCode === 9) {
        e.preventDefault()
        setMostrarAyuda(false)
      }
    },
    [onSelectKeyDown]
  )

  return (
    <>
      <Row>
        <Col md={12}>
          <Form.InputGroup>
            {mostrarAyuda ? (
              <Form.Select {...props} id={selectId} onKeyDown={innerOnSelectKeyDown}>
                <option value=''>Seleccionar</option>
                {mediosPagos.map((x, k) => (
                  <option key={k} value={x._id}>
                    {x.nombre}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Form.InputText {...props} id={inputId} onKeyDown={innerOnInputKeyDown} maxLength={3} />
            )}
            <Form.InputGroup.Append>
              <Button onClick={clickAyuda}>&#x1F892;</Button>
            </Form.InputGroup.Append>
            {props.isInvalid ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
          </Form.InputGroup>
        </Col>
        <Col md={12}>
          <Form.OnlyText text={medioPagoText} />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(MedioPagoFormGroup)
